/*
* <license header>
*/

import React, { useState, useMemo } from 'react'
import { Grid, minmax, repeat, SearchField, View } from '@adobe/react-spectrum'
import { PageHeaderBanner } from './shared/PageHeaderBanner'
import { TypeCard } from './type-browser/TypeCard'
import { AppAssistant } from './shared/AppAssistant'
import { APP_TYPES } from '../data/constants'
import { useFavorites } from '../context/FavoritesContext'

export const AppBuilderTypeBrowser = () => {
  const { isTypeFavorite, toggleTypeFavorite } = useFavorites()
  const [filter, setFilter] = useState('')

  const filteredTypes = useMemo(() => {
    if (!filter.trim()) return APP_TYPES
    const query = filter.trim().toLowerCase()
    return APP_TYPES.filter(
      (type) =>
        type.title.toLowerCase().includes(query) ||
        (type.package && type.package.toLowerCase().includes(query)) ||
        type.description.toLowerCase().includes(query)
    )
  }, [filter])

  return (
    <View width="100%" minWidth={0} padding="size-400" UNSAFE_style={{ paddingBottom: '2.5rem' }}>
      <PageHeaderBanner
        title="App Builder Types"
        subtitle="Adobe Recommended App Builder types (npm package templates)"
      />

      <View padding="size-200" backgroundColor="gray-75" borderWidth="thin" borderColor="gray-300" borderRadius="regular" marginBottom="size-300">
        <SearchField
          aria-label="Search"
          placeholder="Search filter..."
          width="100%"
          value={filter}
          onChange={setFilter}
        />
      </View>

      <Grid
        columns={repeat('auto-fill', minmax('size-3000', '1fr'))}
        autoRows="auto"
        gap="size-200"
        width="100%"
        marginBottom="size-300"
      >
        {filteredTypes.map((type) => (
          <TypeCard
            key={type.slug}
            slug={type.slug}
            title={type.title}
            badge={type.badge}
            description={type.description}
            package={type.package}
            version={type.version}
            isFavorite={isTypeFavorite(type.slug)}
            onToggleFavorite={toggleTypeFavorite}
          />
        ))}
      </Grid>

      <AppAssistant />
    </View>
  )
}
